import { escapeHtml } from './dom.js';

/** Azioni sotto un campo testo: pulsante Salva + stato. */
export function renderTextareaSaveActions(key, label = 'Salva') {
  return `
    <div class="field-save-actions">
      <button type="button" class="btn-primary btn-primary--sm field-save-btn" data-save-key="${escapeHtml(key)}">${escapeHtml(label)}</button>
      <span class="field-save-status" data-save-status="${escapeHtml(key)}" hidden></span>
    </div>
  `;
}

export async function runTextareaSave({ btn, statusEl, save, canSave = () => true }) {
  if (!canSave()) return;

  btn.disabled = true;
  if (statusEl) {
    statusEl.hidden = false;
    statusEl.textContent = 'Salvataggio…';
    statusEl.classList.remove('field-save-status--ok', 'field-save-status--err');
  }

  try {
    await save();
    if (statusEl) {
      statusEl.textContent = 'Salvato';
      statusEl.classList.add('field-save-status--ok');
    }
  } catch (error) {
    if (statusEl) {
      statusEl.textContent = error.message;
      statusEl.classList.add('field-save-status--err');
    } else {
      alert(error.message);
    }
  } finally {
    btn.disabled = false;
  }
}

/**
 * Collega i pulsanti `.field-save-btn` nel container.
 * @param {HTMLElement} container
 * @param {{ canSave?: () => boolean, onSave: (key: string) => Promise<void> }} opts
 */
export function bindTextareaSaveButtons(container, { canSave = () => true, onSave }) {
  container.querySelectorAll('.field-save-btn').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.saveKey;
      if (!key) return;
      const status = container.querySelector(`[data-save-status="${CSS.escape(key)}"]`);
      await runTextareaSave({
        btn,
        statusEl: status,
        canSave,
        save: () => onSave(key),
      });
    });
  });
}
